import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { leadQueueEffects } from 'src/app/lead-queue/store/effects';
import { leadQueueFeatureKey } from 'src/app/lead-queue/store/reducers';
import { leadQueueReducer } from 'src/app/lead-queue/store/reducers/lead-queue.reducers';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(leadQueueFeatureKey, leadQueueReducer),
        EffectsModule.forFeature(leadQueueEffects)
    ]
})
export class LeadQueueStoreModule {}
